import React, { useState, useEffect } from 'react'
import DefaultLayout from './DefaultLayout'
import { Row, Col, Form, Input, Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { addCar, getAllCars } from '../redux/actions/carsActions'
import Spinner from '../components/Spinner'
import { useParams } from 'react-router-dom';
import { updateCar} from '../redux/actions/carsActions';

function EditCar() {
    const { carid } = useParams();
    const { cars } = useSelector(state => state.cars) // ✅ Correct slice name

    const dispatch = useDispatch()
    const { loading } = useSelector(state => state.alertsReducer)
    const [car, setCar] = useState()

    useEffect(() => {
        if (cars.length === 0) {
            dispatch(getAllCars());
        } else {
            const foundCar = cars.find(o => o._id === carid);
            if (foundCar) {
                setCar(foundCar);
            }
        }
    }, [cars, carid, dispatch]);


    function onFinish(values) {
        values._id = car._id;
        values.bookedTimeSlots = car.bookedTimeSlots || [];
        values.rentPerHour = Number(values.rentPerHour);
        values.capacity = Number(values.capacity);

        dispatch(updateCar(values));
    }



    return (
        <DefaultLayout>
            {loading && (<Spinner />)}
            <Row justify='center mt-5'>
                <Col lg={12} sm={24} >
                    {car&&(
                        <Form initialValues={car} className='bs1 p-2' layout='vertical' onFinish={onFinish}>
                        <h3>Edit Car</h3>
                        {car.make}
                        {car.length}
                        <hr />
                        <Form.Item name='make' label='Car make' rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name='image' label='Image url' rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name='rentPerHour' label='Rent per hour' rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name='capacity' label='Capacity' rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="fuelType"
                            label="Fuel Type"
                            rules={[{ required: true, message: 'Please select a fuel type' }]}
                        >
                            <Select placeholder="Select fuel type">
                                <Select.Option value="petrol">Petrol</Select.Option>
                                <Select.Option value="diesel">Diesel</Select.Option>
                                <Select.Option value="electric">Electric</Select.Option>
                            </Select>
                        </Form.Item>

                        <div className='text-right'>
                            <button className='btn1'>Edit Car</button>
                        </div>


                    </Form>
                    )
                    
                    }
                </Col>
            </Row>
        </DefaultLayout>
    )
}

export default EditCar